module.exports = __webpack_public_path__ + "img/oneDesBlue.6ba600f1.jpg";